import type { RootState } from "store/types";

// Shared plain-data shapes for the `game` and related Immutable props that `containers/Categories`
// (via `containers/CategoryList`/`CategoryListDesktop`) and `containers/Search` pass down to list
// item components. Those containers are unconverted and remain generic over both Immutable- and
// plain-prop-consuming list items (PLAY-5154's design "Risks" / "Out of scope"), so the unwind
// happens at each converted tile's own props boundary rather than upstream, unlike
// `store/selectors/filters.ts`'s state-boundary unwind. `toPlain` is the one conversion point;
// the interfaces below are what a converted tile is allowed to read afterwards.

export interface GameImages {
  url?: string;
  bannerUrl?: string;
}

export interface Game {
  name?: string;
  provider?: string;
  gameType?: string;
  jackpotBalance?: number;
  jackpotGroupId?: string;
  hasFreeRounds?: boolean;
  partOfOnGoingTournament?: boolean;
  isFeatured?: boolean;
  isJackpot?: boolean;
  images?: GameImages;
}

export interface GameLink {
  rel: string;
  name?: string;
}

export interface ImageFormat {
  logoRound?: string;
  banner?: string;
}

export interface LatestBroadcast {
  jackpotGroupId?: string;
  type?: string;
  amount?: number;
}

export interface GameLimit {
  minBet?: number;
  maxBet?: number;
}

export function toPlain<T>(value: any): T | undefined {
  return value ? (value.toJS() as T) : undefined;
}

// containers/Application (PLAY-5216, Phase 4): mapStateToProps' `hasGameAction` derivation ported
// verbatim - fed into the `hasModalLaunched` OR-chain, not read on its own, so the raw Immutable
// value (not a boolean) is preserved to keep that chain's semantics identical.
export function selectGameActionParams(state: RootState): any {
  return state.game.get("params");
}

export function selectTileLinks(state: RootState): any {
  return state.game.get("tileLinks");
}

export function tileLinksFor(tileLinks: any, gameId: unknown): any {
  return tileLinks && gameId !== undefined && gameId !== null && tileLinks.get("gameId") === gameId ? tileLinks : undefined;
}
